import { translationKey, type TranslationKey } from '@change-corgi/core/i18n';

const BadgesTypes = {
	GREAT: {
		labelKey: translationKey('corgi.components.badge_score.variants.great'),
		backgroundColor: '#078E3F',
		color: '#FFFFFF',
		stroke: '#0C5B2D',
	},
	GOOD: {
		labelKey: translationKey('corgi.components.badge_score.variants.good'),
		backgroundColor: '#EEFFF5',
		color: '#0C5B2D',
		stroke: '#0DDA62',
	},
	ROOM_TO_IMPROVE: {
		labelKey: translationKey('corgi.components.badge_score.variants.room_to_improve'),
		backgroundColor: '#FFE3A8',
		color: '#7E3B10',
		stroke: '#FE9311',
	},
	BELOW_AVERAGE: {
		labelKey: translationKey('corgi.components.badge_score.variants.below_average'),
		backgroundColor: '#FFFEC7',
		color: '#9D6A0B',
		stroke: '#FFCE71',
	},
};

type UseBadgeScoreReturn = ModelHookResult<{
	labelKey: TranslationKey;
	backgroundColor: string;
	color: string;
	stroke: string;
}>;

export const useBadgeScore = (score: number): UseBadgeScoreReturn => {
	if (score >= 10) {
		return {
			data: {
				...BadgesTypes.GREAT,
			},
		};
	}
	if (score >= 7) {
		return {
			data: {
				...BadgesTypes.GOOD,
			},
		};
	}
	if (score >= 4) {
		return {
			data: {
				...BadgesTypes.ROOM_TO_IMPROVE,
			},
		};
	}
	return {
		data: {
			...BadgesTypes.BELOW_AVERAGE,
		},
	};
};
